/* eslint-disable import/no-webpack-loader-syntax */ import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import wingUrl from '../../../assets/gems/wing.svg?inline';
export function Wing({ ...props }) {
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: wingUrl,
        alt: "WingImage"
    });
}
